import { type FunctionComponent, type ReactNode } from 'react'
import { useFastFind } from '../utils/hooks/useFastFind'
import { useDomainAccessControl } from '../utils/domain/accessControl'
import { CustomerSearchFastFindAccessControl } from '../access-control/customersAndOrdersAdminAccess.configuration'
import FastFindModal from './FastFindModal'

const FastFindProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const hasAccess = useDomainAccessControl()
  const hasFastFindAccess = hasAccess(CustomerSearchFastFindAccessControl)
  const { isOpen, closeModal, navigateToSearch } = useFastFind()
  return (
    <>
      {children}
      {hasFastFindAccess && isOpen && (
        <FastFindModal onClose={closeModal} onSearch={navigateToSearch} />
      )}
    </>
  )
}

export default FastFindProvider
